module.exports = __webpack_public_path__ + "media/good.4747dd14.mp3";